// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-modal-container {
  height: calc(100vh - 160px);
  overflow: auto; }

.ant-drawer-header {
  background-color: vaR(--primary-20); }

.ant-drawer-title {
  color: vaR(--primary-100); }

.required-field {
  color: red; }

.modal-dialog-footer {
  padding: 24px 0 0;
  border-top: 1px solid vaR(--grey-light2); }

.hide {
  display: none; }
`, "",{"version":3,"sources":["webpack://./src/component/dialog/dialog.scss"],"names":[],"mappings":"AAAA;EACI,2BAA2B;EAC3B,cAAc,EAAA;;AAGlB;EACI,mCAAmC,EAAA;;AAIvC;EACI,yBAAyB,EAAA;;AAG7B;EACI,UAAU,EAAA;;AAGd;EACI,iBAAiB;EACjB,wCAAwC,EAAA;;AAG5C;EACI,aAAa,EAAA","sourcesContent":[".dialog-modal-container {\n    height: calc(100vh - 160px);\n    overflow: auto;\n}\n\n.ant-drawer-header {\n    background-color: vaR(--primary-20);\n\n}\n\n.ant-drawer-title {\n    color: vaR(--primary-100);\n}\n\n.required-field {\n    color: red;\n}\n\n.modal-dialog-footer {\n    padding: 24px 0 0;\n    border-top: 1px solid vaR(--grey-light2);\n}\n\n.hide {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
